export default {"src":"/_next/static/media/bookmark.df90f256.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};